import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Page} from "./models/page";
import {PageService} from "./services/page.service";
import {ActivatedRoute, Router} from "@angular/router";
declare var $: any;

@Component({
    selector: 'app-addpage',
    templateUrl: './addpage.component.html'
})
export class AddpageComponent implements OnInit {
    title:string = "Add page";
    iPageId = 0;
    pageform: FormGroup;
    pageinfo: Page;
    isEdit: boolean = false;
    ckeditorContent;
    constructor(
        private pageService:PageService,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.params.subscribe(params => {
            this.iPageId = params["id"];
        });
        if(this.iPageId > 0){
            this.isEdit = true;
        }
        if(this.iPageId > 0){
            this.title = "Edit page";
        }
    }

    ngOnInit() {
        this.title;
        this.isEdit;
        this.pageform = this.fb.group({
            vTitle: ['',
                Validators.required
            ],
            tDescription:['',
                Validators.required
            ],
            // vSlug: ['',
            //     Validators.required
            // ]
        });

        if (this.isEdit) {
            this.getPageInfo();
        }
        this.loadScriptLibrary();
    }

    onSubmit(pageValue) {
        if(this.isEdit){
            this.updateForm(pageValue);
        }else{
            this.addForm(pageValue);
        }
    }

    addForm(pageValue){
        $('#save_page').button('loading');
        this.pageService.createPage(pageValue).then(PageData => {
            if(PageData['status'] === 200){
                $('#save_page').button('reset');
                $.toast({heading: 'Success', text: PageData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/pages']);
            }else{
                $.toast({heading: 'Warning', text: PageData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#save_page').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#save_page').button('reset');
        });
    }

    updateForm(pageValue){
        $('#update_page').button('loading');
        pageValue['iPageId'] = this.iPageId;
        this.pageService.updatePage(pageValue).then(PageData => {
            if(PageData['code'] === 200){
                $('#update_page').button('reset');
                $.toast({heading: 'Success', text: PageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/pages']);
            }else{
                console.log(PageData['message']);
                $.toast({heading: 'Warning', text: PageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#update_page').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#update_page').button('reset');
        });
    }

    getPageInfo=function () {
        this.pageService.getPageInfo(this.iPageId).then(data => {
            console.log("PageInfo=======>",data['data']);
            this.pageinfo = data['data'];
            this.patchForm();
        });
    }

    patchForm() {
        console.log("PageInfoDetails=======>"+this.pageinfo.Title)
        this.pageform.patchValue({
            vTitle: this.pageinfo.Title,
            // vSlug: this.pageinfo.vSlug,
            tDescription:this.pageinfo.Description,
        })
    }

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/pages/addpage.component.ts